@if (item) {
  <div class="root-container">
    <div class="content-container">
      <div class="email-preview-container">
        <app-email-preview
          [heightModified]="true"
          [item]="item.en"
          (previewHeadlineClicked)="previewHeadlineClicked()"
          (previewItemClicked)="previewItemClicked($event)"></app-email-preview>
        <mat-tab-group
          class="tab-group"
          mat-stretch-tabs
          [preserveContent]="true"
          [(selectedIndex)]="tabIndex">
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="example-tab-icon">construction</mat-icon>
              {{ 'cms.emails.edit.tabs.build.headline' | translate }}
            </ng-template>
            <div class="tab-content-container">
              <div class="email-components-container">
                <mat-accordion
                  class="cms-drag-list"
                  cdkDropList
                  (cdkDropListDropped)="drop($event, $safeNavigationMigration(item?.en?.content))">
                  <mat-expansion-panel
                    [id]="headlineExpansionPanelId"
                    [expanded]="clickedItemId === headlineExpansionPanelId">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <h4>
                          {{ 'cms.emails.main-headline' | translate }}
                          <span class="cut-text">{{ getItemInfoData(item) }}</span>
                        </h4>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <coin-a-email-header
                        [showBackgroundPicker]="true"
                        [item]="item"></coin-a-email-header>
                    </ng-template>
                  </mat-expansion-panel>
                </mat-accordion>
                <div style="display: flex; gap: 10px"></div>
                <mat-accordion
                  class="cms-drag-list"
                  cdkDropList
                  (cdkDropListDropped)="drop($event, $safeNavigationMigration(item?.en?.content))">
                  @if (item?.en?.content.length === 0) {
                    <p style="text-align: center; margin-top: 20px">
                      {{ 'cms.emails.no-content-information' | translate }}
                    </p>
                  }
                  @for (subItem of item?.en?.content; track subItem; let i = $index) {
                    <div class="cms-item cms-drag-box mep-second">
                      <coin-icon-button
                        type="outline"
                        icon="add"
                        class="add-button no-style"
                        (click)="addContent(subItem)" />
                      <mat-expansion-panel
                        cdkDrag
                        [id]="getItemExpansionPanelId(subItem)"
                        [expanded]="clickedItemId === getItemExpansionPanelId(subItem)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <h4 style="text-transform: capitalize">
                              {{ subItem.type }}
                              <span class="cut-text">{{ getSubItemInfoData(subItem) }}</span>
                            </h4>
                            <span
                              class="material-icons"
                              cdkDragHandle
                              style="position: absolute; top: 15px; right: 40px; cursor: move">
                              drag_indicator
                            </span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <!-- no lazy loading for index list due to reactivity -->
                        @if (subItem.type === 'index-list') {
                          <coin-email-index-list
                            [item]="subItem"
                            [content]="item.en.content"></coin-email-index-list>
                        }
                        @if (subItem.type === 'email-footnotes') {
                          <coin-a-email-footnotes [item]="$any(subItem)"></coin-a-email-footnotes>
                        }

                        <!-- lazy loaded items -->
                        <ng-template matExpansionPanelContent>
                          <div>
                            @if (subItem.type === 'spacer') {
                              <coin-gmm-spacer
                                [contentEdit]="true"
                                [showBackgroundPicker]="true"
                                [item]="subItem"></coin-gmm-spacer>
                            }
                            @if (
                              subItem.type === 'editor' ||
                              subItem.type === 'bullet-list' ||
                              subItem.type === 'email-headline'
                            ) {
                              <coin-html-editor
                                [contentEdit]="true"
                                [showAdditionalEditOptions]="true"
                                [item]="subItem"></coin-html-editor>
                            }
                            @if (subItem.type === 'download-file') {
                              <coin-download-file
                                [showAdditionalEditOptions]="true"
                                [contentEdit]="true"
                                [item]="subItem"></coin-download-file>
                            }
                            @if (subItem.type === 'line') {
                              <coin-gmm-line
                                [showBackgroundPicker]="true"
                                [contentEdit]="true"
                                [item]="subItem"></coin-gmm-line>
                            }
                            @if (subItem.type === 'email-button') {
                              <coin-email-button
                                [showBackgroundPicker]="true"
                                [contentEdit]="true"
                                [item]="subItem"></coin-email-button>
                            }
                            @if (subItem.type === 'email-quote') {
                              <coin-a-email-quote
                                [showBackgroundPicker]="true"
                                [contentEdit]="true"
                                [item]="$any(subItem)"></coin-a-email-quote>
                            }
                            @if (subItem.type === 'single-or-multi-image') {
                              <coin-email-single-double-image
                                [showBackgroundPicker]="true"
                                [contentEdit]="true"
                                [editImageLink]="true"
                                [item]="subItem"></coin-email-single-double-image>
                            }
                            @if (subItem.type === 'video') {
                              <coin-email-video
                                [contentEdit]="true"
                                [showBackgroundPicker]="true"
                                [item]="subItem"></coin-email-video>
                            }
                            @if (subItem.type === 'main-body-image-text') {
                              <coin-email-main-body-image-text
                                [showAdditionalEditOptions]="true"
                                [contentEdit]="true"
                                [item]="subItem"></coin-email-main-body-image-text>
                            }
                            <div style="display: flex; justify-content: flex-end; margin-top: 20px">
                              <coin-v2-button
                                [type]="'secondary'"
                                [iconPos]="'right'"
                                [icon]="'close'"
                                [text]="'cms.emails.remove-content' | translate"
                                (click)="removeContent($safeNavigationMigration(item?.en?.content), i)"></coin-v2-button>
                            </div>
                          </div>
                        </ng-template>
                      </mat-expansion-panel>
                    </div>
                  }
                </mat-accordion>
                <div class="button-container">
                  <coin-v2-button
                    [type]="'primary'"
                    [icon]="'add'"
                    [iconPos]="'right'"
                    [text]="'cms.emails.add-content' | translate"
                    (click)="addContent()"></coin-v2-button>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="example-tab-icon">settings</mat-icon>
              {{ 'cms.emails.edit.tabs.settings.headline' | translate }}
            </ng-template>
            <div class="tab-content-container">
              <mat-card>
                <mat-card-content class="default-padding-card-content">
                  <h3>{{ 'cms.emails.edit.tabs.settings.headline' | translate }}</h3>
                  <h5>{{ 'cms.emails.edit.settings.default-padding.headline' | translate }}</h5>
                  <span>{{ 'cms.emails.edit.settings.default-padding.information' | translate }}</span>
                  @if (defaultPadding === undefined) {
                    <span class="no-default-padding-information">
                      <mat-icon>info_outline</mat-icon>
                      {{ 'cms.emails.edit.settings.default-padding.no-default-padding-information' | translate }}
                    </span>
                  }
                  <coin-email-slider
                    [ngModel]="defaultPadding"
                    (ngModelChange)="onDefaultPaddingChange($event)"></coin-email-slider>
                </mat-card-content>
                <mat-card-content class="branding-card-content">
                  <h5>{{ 'cms.emails.edit.settings.branding.headline' | translate }}</h5>
                  <coin-v2-checkbox
                    [label]="'cms.emails.edit.settings.branding.text' | translate"
                    [ngModel]="isGenericBranding"
                    (ngModelChange)="onGenericBrandingChange($event)" />
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
}
